export default {
  Nome: {
    name: 'general.name',
    maxLength: 25,
  },
  RigidezDieletrica: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.dielectric-strength',
    minimum: 0,
    maximum: 1000000,
    precision: 2,
  },
  IndiceNeutralizacao: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.neutralization-index',
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  TensaoInterfacial25: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.interfacial-tension',
    temperature: 25,
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  TeorAgua: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.water-content',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  TeorAgua20: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.water-content-20',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  FatorDissipacao25: {
    name: 'fields.physical-chemical-analysis.dissipation-factor',
    temperature: 25,
    minimum: 0,
    maximum: 100,
    precision: 3,
  },
  FatorDissipacao90: {
    name: 'fields.physical-chemical-analysis.dissipation-factor',
    temperature: 90,
    minimum: 0,
    maximum: 100,
    precision: 3,
  },
  FatorDissipacao100: {
    name: 'fields.physical-chemical-analysis.dissipation-factor',
    temperature: 100,
    minimum: 0,
    maximum: 100,
    precision: 3,
  },
  Cor: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.color',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  CorAntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.color-before-filling',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  DensidadeRelativa: {
    name: 'fields.physical-chemical-analysis.relative-density',
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  DensidadeRelativaAntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.relative-density',
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  TeorPcbNivelContem: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.pcb-content',
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  TeorPcbNivelContaminado: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.pcb-content-contaminated',
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  TeorDbds: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.dbds-content',
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  TeorPassivador: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.passivator-content',
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  TaxaDecaimentoPassivador: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.passivator-decay-rate',
    minimum: 0,
    maximum: 1000000,
    precision: 2,
  },
  TeorInibidorDbpc: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.dbpc-inhibitor-content-percentage',
    minimum: 0,
    maximum: 100,
    precision: 3,
  },
  TeorInibidorOriginal: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.original-dbpc-inhibitor-content',
    minimum: 0,
    maximum: 100,
    precision: 3,
  },
  PorcentagemTeorOriginalInibidorDbpc: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.percentage-original-dbpc-inhibitor-content',
    minimum: 0,
    maximum: 100,
    precision: 3,
  },
  TotalGasesDissolvidosOleo: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.dissolved-gases',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  Resistividade90: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.resistivity',
    minimum: 0,
    maximum: 1000000,
    temperature: 90,
    precision: 3,
  },
  Resistividade20: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.resistivity',
    minimum: 0,
    maximum: 1000000,
    temperature: 20,
    precision: 3,
  },
  ContagemParticulas: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.particle-count',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  ContagemParticulasAntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.particle-count-before-filling',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  ContagemParticulasAposEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.particle-count-after-filling',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  PontoFulgor: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.flash-point',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  PontoFulgorDiferencaGraus: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.flash-point-degrees-difference',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  PontoFulgorDiferencaPorcentagem: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.flash-point-percent-difference',
    minimum: 0,
    maximum: 100,
    precision: 1,
  },
  Rbot: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.rbot',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  SaturacaoOleoNivelIsolacaoModeradamenteUmida: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.oil-saturation-insulation-level-moderately-humid',
    minimum: 0,
    maximum: 100,
    precision: 1,
  },
  SaturacaoOleoNivelIsolacaoUmida: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.oil-saturation-insulation-level-humid',
    minimum: 0,
    maximum: 100,
    precision: 1,
  },
  SaturacaoOleoNivelIsolacaoExtremamenteUmida: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.oil-saturation-insulation-level-extremely-humid',
    minimum: 0,
    maximum: 100,
    precision: 1,
  },
  RigidezDieletricaAntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.dielectric-strength-before-filling',
    minimum: 0,
    maximum: 1000000,
    precision: 2,
  },
  FatorDissipacao25AntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.dissipation-factor-before-filling',
    minimum: 0,
    maximum: 100,
    temperature: 25,
    precision: 3,
  },
  FatorDissipacao100AntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.dissipation-factor-before-filling',
    minimum: 0,
    maximum: 100,
    temperature: 100,
    precision: 3,
  },
  TensaoInterfacial25AntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.interfacial-tension-before-filling',
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  IndiceNeutralizacaoAntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.neutralization-index-before-filling',
    minimum: 0,
    maximum: 1000000,
    precision: 3,
  },
  TeorAguaAntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.water-content-before-filling',
    minimum: 0,
    maximum: 1000000,
    precision: 1,
  },
  TeorInibidorDbpcAntesEnchimento: {
    name: 'fields.engineering.physical-chemical.vertical-parameters.dbpc-inhibitor-content-before-filling',
    minimum: 0,
    maximum: 100,
    precision: 3,
  },
};
